<template>
    <div>
        <Modal :id="'ExemploEmailProposta'" :size="''" :FooterDefault="false">
            <template v-slot:header>
                <h6 class="modal-title">Exemplo de E-mail</h6>
                <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close"><i
                        class="fas fa-times btn-close-style"></i></button>
            </template>
            <template v-slot:body>
                <div class="row col-12">
                    <div class="col-4"></div>
                    <div class="col-4 modal-body-ExEmail mt-3 bg-white h-100">
                        <span style='color: #990000; font-size: x-large;'>
                            <strong>
                                <em>Envio de Proposta</em>
                            </strong>
                        </span>
                        <hr />
                        <p style='font-family: "Calibri", sans-serif'>
                            Prezado(a) Sr(a). {{ nmContatoCliente }}
                        </p>
                        <p id="txt_corpo_email" style='font-family: "Calibri", sans-serif'>
                            {{ dsCorpoEmail }}
                        </p>
                        <p style='font-family: "Calibri", sans-serif'>
                            Para acessar as <b>certidões atualizadas</b> e outros documentos relacionados a contratação, <a
                                href=urlProposta target="_blank">clique aqui</a>.
                        </p>
                        <p style='font-family: "Calibri", sans-serif'>
                            Att,
                        </p>
                        <p
                            style='margin-bottom: .0001pt; font-size: 11.0pt; font-family: "Calibri", sans-serif; margin-left: 0cm; margin-right: 0cm; margin-top: 0cm;'>
                            <b>
                                <span style='color: #C00000; mso-fareast-language: PT-BR'>{{ nmUsuario }}</span>
                            </b>
                            <br />
                            <b>
                                <span style='font-size: 10.0pt; color: #595959; mso-fareast-language: PT-BR'>Grupo Negócios
                                    Públicos</span>
                            </b>
                            <br />
                            <span
                                style='font-size: 10.0pt; line-height: 110%; color: #595959; mso-fareast-language: PT-BR'>(41)
                                3778-1700&nbsp;&nbsp;| &nbsp;</span>
                            <span style='color: #1F497D; mso-fareast-language: PT-BR'>
                                <span
                                    style='font-size: 10.0pt; line-height: 110%; color: #595959'>www.negociospublicos.com.br</span>
                            </span>
                            <span style='font-size: 10.0pt; line-height: 110%; color: #595959; mso-fareast-language: PT-BR'>
                                <span
                                    style='font-size: 10.0pt; line-height: 110%; color: #595959; mso-fareast-language: PT-BR'>|
                                    &nbsp;</span>
                                <span style='color: #1F497D; mso-fareast-language: PT-BR'>
                                    <span
                                        style='font-size: 10.0pt; line-height: 110%; color: #595959'>falecom@negociospublicos.com.br</span>
                                </span>
                            </span>
                            <br />
                            <span
                                style='font-size: 10.0pt; line-height: 110%; color: #595959; mso-fareast-language: PT-BR'>R.
                                Dr. Brasílio Vicente de Castro, 111 - Campo Comprido – 10º andar | Curitiba-PR – CEP
                                81200-526</span>
                        </p>
                    </div>
                    <div class="col-4"></div>
                </div>
            </template>

            <template v-slot:footer>
                <div class="modal-footer">                    
                </div>
            </template>

        </Modal>

    </div>
</template>
<script>

import axios from 'axios';
import Modal from '@/components/App/Modal.vue'

export default {
    name: 'ExemploEmailProposta',
    components: {
        Modal,
    },
    props: {
        nmContatoCliente: {
            type: String,
            default: ''
        },
        dsCorpoEmail: {
            type: String,
            default: ''
        }
        //idOcorrencia: {
        //    type: Number,
        //    default: 0
        //},
    },
    data() {
        return {
            urlProposta: 'https://gnp.negociospublicos.com.br/arquivo/',
            nmUsuario: ''
        }
    },
    computed: {
    },
    methods: {

        getDadosUser() {
            let $this = this;

            axios.get(process.env.VUE_APP_ROOT_API_PLATAFORMA + '/Principal/GetDadosUser', {
                headers: $this.$api.getTokenPlataforma(),
                params: ''
            }).then(response => {
                $this.nmUsuario = response.data.data.nmUsuario;

            });

        }

    },
    created() {
    },
    mounted() {
        this.getDadosUser();
    },
    watch: {

    },
}

</script>

<style scope lang="scss"></style>